const PROPERTY_NAV_CACHE_KEY = 'zrm_property_nav_address';

export type CachedPropertyAddress = {
  street: string;
  city: string;
  state: string;
  unit: string;
  zip: string;
};

export function cachePropertyAddress(address: CachedPropertyAddress): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(PROPERTY_NAV_CACHE_KEY, JSON.stringify(address));
  } catch {
    // Silently fail if sessionStorage is unavailable
  }
}

export function getCachedPropertyAddress(): CachedPropertyAddress | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(PROPERTY_NAV_CACHE_KEY);
    return raw ? (JSON.parse(raw) as CachedPropertyAddress) : null;
  } catch {
    return null;
  }
}
